// ============================================
// MEGA MENU SMOOTH ANIMATION - BIDIRECTIONAL HEIGHT TRANSITION
// Implements smooth height transitions in both directions (expand & shrink)
// ============================================

(function () {
  'use strict';

  class MegaMenuAnimation {
    constructor() {
      this.navItems = document.querySelectorAll('.site-nav__item.site-nav--is-megamenu');
      console.log('Found mega menu items:', this.navItems.length);
      
      this.currentOpen = null;
      this.openTimeout = null;
      this.closeTimeout = null;
      this.isDesktop = false;
      this.closingDropdown = null; // FIX: tracks which dropdown is mid-close animation
      this.mediaQuery = window.matchMedia('(min-width: 992px)');
      this.isTransitioning = false;

      if (this.navItems.length > 0) {
        this.init();
      } else {
        console.warn('No mega menu items found!');
      }
    }

    init() {
      this.checkMediaQuery();

      this.mediaQuery.addEventListener('change', () => {
        this.checkMediaQuery();
      });

      this.navItems.forEach((navItem) => {
        const details = navItem.querySelector('.site-nav__details[data-hover="true"]');
        const summary = details ? details.querySelector('summary') : null;
        const dropdown = navItem.querySelector('.site-nav__dropdown.megamenu');

        if (!details || !summary || !dropdown) {
          return;
        }

        // Initialize dropdown to closed state
        this.initializeDropdown(dropdown);

        // Prevent default click behavior on desktop
        summary.addEventListener('click', (e) => {
          if (this.isDesktop) e.preventDefault();
        });

        // Mouse enter on the entire nav item
        navItem.addEventListener('mouseenter', () => {
          if (!this.isDesktop) return;

          this.clearTimeouts();
          this.openTimeout = setTimeout(() => {
            this.openMenu(navItem, details, dropdown);
          }, 50);
        });

        // Mouse leave from the entire nav item
        navItem.addEventListener('mouseleave', () => {
          if (!this.isDesktop) return;

          this.clearTimeouts();
          this.closeTimeout = setTimeout(() => {
            this.closeMenu(details, dropdown);
          }, 150);
        });
      });
    }

    initializeDropdown(dropdown) {
      // FIX: Never use display:none — it breaks scrollHeight measurements
      // Use visibility:hidden + height:0 + pointer-events:none instead
      dropdown.style.display = 'block';       // CHANGED: was not set, now always block
      dropdown.style.opacity = '0';
      dropdown.style.visibility = 'hidden';
      dropdown.style.height = '0';
      dropdown.style.overflow = 'hidden';
      dropdown.style.pointerEvents = 'none';
    }

    checkMediaQuery() {
      const wasDesktop = this.isDesktop;
      this.isDesktop = this.mediaQuery.matches;

      if (wasDesktop && !this.isDesktop) {
        this.cleanupDesktopStyles();
      }
    }

    cleanupDesktopStyles() {
      this.navItems.forEach(navItem => {
        const details = navItem.querySelector('.site-nav__details[data-hover="true"]');
        const dropdown = navItem.querySelector('.site-nav__dropdown.megamenu');
        
        if (dropdown) {
          this.initializeDropdown(dropdown);
        }
        if (details) {
          details.removeAttribute('open');
        }
      });
      this.currentOpen = null;
    }

    openMenu(navItem, details, dropdown) {
      if (!this.isDesktop) return;

      // FIX: If this dropdown is mid-close animation, snap it back to open
      // without this, re-hovering during close leaves details without 'open'
      // and the height/visibility are in a broken intermediate state
      if (this.closingDropdown === dropdown) {
        this.closingDropdown = null;
        dropdown.style.transition = 'none';
        dropdown.style.opacity = '1';
        dropdown.style.visibility = 'visible';
        dropdown.style.pointerEvents = 'auto';
        dropdown.style.height = 'auto';
        dropdown.style.overflow = 'visible';
        details.setAttribute('open', '');
        details.setAttribute('aria-expanded', 'true');
        this.currentOpen = { dropdown, details };
        return;
      }

      // FIX: Always ensure display:block before any measurement
      dropdown.style.display = 'block';

      // Check if we're switching between menus
      const isSwitchingMenus = this.currentOpen && this.currentOpen.dropdown !== dropdown;
      
      if (isSwitchingMenus) {
        // Get the current height of the open menu
        const currentHeight = this.currentOpen.dropdown.offsetHeight;
        
        // Measure the new menu's height
        dropdown.style.display = 'block';      // FIX: explicit guard
        dropdown.style.visibility = 'hidden';
        dropdown.style.height = 'auto';
        dropdown.style.position = 'absolute';
        dropdown.style.opacity = '0';
        
        const newHeight = dropdown.scrollHeight;
        
        // Reset styles
        dropdown.style.position = '';
        dropdown.style.visibility = '';
        dropdown.style.height = '';
        
        // Perform instant content swap with smooth height transition
        this.switchMenus(details, dropdown, currentHeight, newHeight);
      } else {
        // First time opening - full animation
        this.performOpen(details, dropdown);
      }
    }

    switchMenus(details, dropdown, fromHeight, toHeight) {
      // STEP 1: Instantly hide old menu content (no animation)
      if (this.currentOpen) {
        const oldDropdown = this.currentOpen.dropdown;
        const oldDetails = this.currentOpen.details;
        
        oldDropdown.style.transition = 'none';
        oldDropdown.style.opacity = '0';
        oldDropdown.style.visibility = 'hidden';
        oldDropdown.style.pointerEvents = 'none';
        // FIX: Do NOT set display:none — keep display:block for future measurements
        
        oldDetails.removeAttribute('open');
        oldDetails.setAttribute('aria-expanded', 'false');
      }

      // STEP 2: Prepare new menu
      dropdown.style.display = 'block';        // FIX: explicit guard
      dropdown.style.visibility = 'visible';
      dropdown.style.pointerEvents = 'auto';
      dropdown.style.overflow = 'hidden';
      
      // Set starting height (from previous menu)
      dropdown.style.height = fromHeight + 'px';
      dropdown.style.transition = 'none';
      
      // Make content immediately visible
      dropdown.style.opacity = '1';
      
      // Set open state
      details.setAttribute('open', '');
      details.setAttribute('aria-expanded', 'true');
      
      // Force reflow
      void dropdown.offsetHeight;
      
      // STEP 3: Animate height smoothly (works for both expand AND shrink)
      dropdown.style.transition = 'height 1s cubic-bezier(0.4, 0, 0.2, 1)';
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          dropdown.style.height = toHeight + 'px';
        });
      });
      
      // Clean up after animation
      setTimeout(() => {
        if (dropdown.style.opacity === '1') {
          dropdown.style.height = 'auto';
          dropdown.style.overflow = 'visible';
        }
      }, 1000);
      
      this.currentOpen = { dropdown, details };
    }

    performOpen(details, dropdown) {
      // FIX: Always ensure display:block before measuring
      dropdown.style.display = 'block';

      // Measure target height
      dropdown.style.visibility = 'hidden';
      dropdown.style.height = 'auto';
      dropdown.style.position = 'absolute';
      
      const targetHeight = dropdown.scrollHeight;
      
      // Reset and prepare for animation
      dropdown.style.position = '';
      dropdown.style.visibility = 'visible';
      dropdown.style.height = '0';
      dropdown.style.opacity = '0';
      dropdown.style.overflow = 'hidden';
      
      // Force reflow
      void dropdown.offsetHeight;
      
      // Set transition
      dropdown.style.transition = 
        'height 1s cubic-bezier(0.4, 0, 0.2, 1), ' +
        'opacity 0.8s ease 0.05s';
      
      // Animate to open
      requestAnimationFrame(() => {
        dropdown.style.height = targetHeight + 'px';
        dropdown.style.opacity = '1';
        dropdown.style.pointerEvents = 'auto';
      });
      
      // Set open attributes
      details.setAttribute('open', '');
      details.setAttribute('aria-expanded', 'true');
      
      // Clean up after animation
      setTimeout(() => {
        if (dropdown.style.opacity === '1') {
          dropdown.style.height = 'auto';
          dropdown.style.overflow = 'visible';
        }
      }, 1000);
      
      this.currentOpen = { dropdown, details };
    }

    closeMenu(details, dropdown) {
      if (!this.isDesktop) return;

      // FIX: Track which dropdown is animating closed
      // so openMenu can detect a mid-close re-hover and snap it back
      this.closingDropdown = dropdown;

      // Get current height for smooth close
      const currentHeight = dropdown.offsetHeight;
      
      // Set explicit height
      dropdown.style.height = currentHeight + 'px';
      dropdown.style.overflow = 'hidden';
      
      // Force reflow
      void dropdown.offsetHeight;
      
      // Set transition
      dropdown.style.transition = 
        'height 0.8s cubic-bezier(0.4, 0, 0.2, 1), ' +
        'opacity 0.7s ease';
      
      // Animate close
      requestAnimationFrame(() => {
        dropdown.style.opacity = '0';
        dropdown.style.height = '0';
        dropdown.style.pointerEvents = 'none';
      });

      // FIX: Move ALL state resets inside setTimeout so they only fire
      // if the close animation actually completes (not interrupted by re-hover)
      setTimeout(() => {
        // Only finalize if this close was NOT cancelled by a re-hover
        if (this.closingDropdown === dropdown) {
          dropdown.style.visibility = 'hidden';
          details.removeAttribute('open');           // MOVED: was before setTimeout
          details.setAttribute('aria-expanded', 'false'); // MOVED: was before setTimeout
          this.closingDropdown = null;
        }
      }, 800);
      
      if (this.currentOpen && this.currentOpen.dropdown === dropdown) {
        this.currentOpen = null;
      }
    }

    clearTimeouts() {
      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
        this.openTimeout = null;
      }
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      // FIX: clear the closing flag too so snap-back logic works correctly
      this.closingDropdown = null;
    }
  }

  function initMegaMenu() {
    console.log('Initializing Smooth Mega Menu...');
    new MegaMenuAnimation();
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }

  // Reinitialize in Shopify theme editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initMegaMenu);
  }
})();

/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

/**/
window.addEventListener('load', function () {
  const homeSlider = document.querySelector('.home-slider');

  if (homeSlider) {
    homeSlider.classList.remove('onload-home-slider');
  }
});

/**/
window.addEventListener('load', function () {
  const homeSlider = document.querySelector('.hm-category-sec');

  if (homeSlider) {
    homeSlider.classList.remove('onload-cat');
  }
});



(function () {
  function addViewAll() {
    const wrapper = document.querySelector('#klaviyo-reviews-carousel-wrapper');

    if (!wrapper) return;

    const prevButton = wrapper.querySelector(
      'button[aria-label="Slideshow previous button"]'
    );

    if (!prevButton) return;

    if (wrapper.querySelector('.custom-view-all')) return;

    const link = document.createElement('a');

    link.href = '/pages/reviews';
    link.textContent = 'View all';
    link.className = 'custom-view-all';

    prevButton.before(link);

      }

  // Run now
  addViewAll();

  // Klaviyo loads/rebuilds the carousel dynamically
  const observer = new MutationObserver(function () {
    addViewAll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();